import Axios from "axios";
import { estados, fuentes } from "@/base/commissionFilters.js";
import { globalData } from "@/main";
import  AppConfig   from "@/config/AppConfig";

export default {
  getEstados() { 
    //return Axios.get("/catalogs/agencies");
    return estados();    
  },
  getFuentes() {    
    //return Axios.get("/catalogs/agencies");
    return fuentes();    
  },

  visualize(any, apsUserName, agencyId, idApsVt) {
    const params = {
      apsUserName: apsUserName,
      idApsVt: idApsVt,
      agencyId: agencyId,
      any: any,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
      if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    return Axios.get("/commission/visualize", {
      params: params,
    });
  },

  getSquareCommission(payload) {
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/squareComissionReport", {
      params: payload,
    });
  },

  getSquareCommissionPdf(payload) {
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/squareComissionPdf", {
      responseType: "arraybuffer",
      params: payload,
    });
  },
  getSquareCommissionExcel(payload) {
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/squareComissionXls", {
      responseType: "arraybuffer",
      params: payload,
    });
  },
  
  preliquidationGeneration(data, apsUserName, agencyId, idApsVt) {
    const params = {
      apsUserName: apsUserName,
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
    if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post("/commission/preliquidationGeneration", data, {
      params: params,
    });
  },
  preliquidationApprove(data, idApsVt, agencyId) {
    const params = {
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post(
      "/commission/preliquidationApprove",
      {
        preliquidationsId: data,
      },
      {
        params: params,
      }
    );
  },
  preliquidationApproveAndBill(data, idApsVt, agencyId) {
    const params = {
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post(
      "/commission/preliquidationApproveAndBill",
      {
        preliquidationsId: data,
      },
      {
        params: params,
      }
    );
  },
  preliquidationReject(data, idApsVt, agencyId) {
    const params = {
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post(
      "/commission/preliquidationReject",
      {
        preliquidationsId: data,
      },
      {
        params: params,
      }
    );
  },
  commissionsMassive(apsId, agencyId, email) {
    const params = {
      apsId: apsId,
      agencyId: agencyId,
      email: email,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/commissionsMassive", {
      params: params,
    });
  },
  preliquidationMassive(id, email) {
    const params = {
      id: id,
      email: email,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/preliquidationMassive", {
      params: params,
    });
  },
  liquidationMassive(id, email) {
    const params = {
      id: id,
      email: email,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/liquidationMassive", {
      params: params,
    });
  },
  visualizePdf(apsUserName, idApsVt, agencyId) {
    const params = {
      apsUserName: apsUserName,
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
     if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/visualizePdf", {
      responseType: "arraybuffer",
      params: params,
    });
  },
  visualizeExcel(apsUserName, idApsVt, agencyId) {
    const params = {
      apsUserName: apsUserName,
      idApsVt: idApsVt,
      agencyId: agencyId,
    };
    if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/visualizeExcel", {
      responseType: "arraybuffer",
      params: params,
    });
  },
  commissionsPdf(ids, apsUserName) {
    const params = {
      apsUserName: apsUserName,
      ids: ids.toString(),
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/commissionsPdf", {
      responseType: "arraybuffer",
      params: params,
    });
  },
  commissionsApprovalExcel(id) {
    const params = {
      id: id.toString(),
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/commissionsXls", {
      responseType: "arraybuffer",
      params: params,
    });
  },
  validatePermission(apsRuc) {
    const params = {
      apsRuc: apsRuc,
    };
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/validatePermission", {
      params: params,
    });
  },
  preliquidation(any, idApsVt, agencyId) {
    const params = {
      idApsVt: idApsVt,
      agencyId: agencyId,
      any: any,
    };
      if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/preliquidation", {
      params: params,
    });
  },
  liquidation(any, idApsVt, agencyId, dateOpts) {
    const params = {
      idApsVt: idApsVt,
      agencyId: agencyId,
      any: any,
    };
    if (dateOpts && dateOpts.fechaPagoDesde && dateOpts.fechaPagoHasta) {
      params.fechaPagoDesde = dateOpts.fechaPagoDesde;
      params.fechaPagoHasta = dateOpts.fechaPagoHasta;
    }
    if(!globalData.validaSucursal ){
        params.agencyId = 0;
      }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.get("/commission/liquidation", {
      params: params,
    });
  },
  comissionReport(data) {
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
        if(!globalData.validaSucursal ){
        data.agencia = 0;
      }

    return Axios.post("/commission/comissionReport", data);
  },
  preliquidationQuery(data) {
       if(!globalData.validaSucursal ){
        data.IdAgencia = 0;
      }
      console.log("data en service");
      console.log(data);
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post("/commission/preliquidationQuery", data);
  },
    IsUserAgent(userId){

		const res = Axios.get(AppConfig.siaerpBaseUrl + `Siaerp/GetAgenteById?idUsuario=${userId}`)
    console.log(res)
    return res
	},
  preliquidationQueryExcel(data) {
    if(!globalData.validaSucursal ){
      data.IdAgencia = 0;
    }
    Axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("accessToken");
    return Axios.post("/commission/preliquidationQueryExcel", data, {
      responseType: "arraybuffer",
    });
  },
};